'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.hasCookieStorage = hasCookieStorage;

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SESSION_TOKEN_KEY = 'access_token';
var SESSION_REFRESH_TOKEN_KEY = 'refresh_token';

/**
 * Checks if the browser has the capabilities to handle cookies
 *
 * @returns {boolean}
 */
function hasCookieStorage() {
    return navigator && navigator.cookieEnabled;
}

/**
 * Provides functionality to manipulate and check a cookie
 * that keeps a user session.
 * Maximum session lifetime until the browser is closed.
 */

var CookieStorage = function () {
    function CookieStorage() {
        (0, _classCallCheck3.default)(this, CookieStorage);
    }

    (0, _createClass3.default)(CookieStorage, [{
        key: 'getSessionToken',
        value: function getSessionToken() {
            return getSession(SESSION_TOKEN_KEY);
        }
    }, {
        key: 'saveSessionToken',
        value: function saveSessionToken(token) {
            document.cookie = SESSION_TOKEN_KEY + '=' + token + ';path=/';
        }
    }, {
        key: 'deleteSessionToken',
        value: function deleteSessionToken() {
            document.cookie = SESSION_TOKEN_KEY + '=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        }
    }, {
        key: 'getRefreshToken',
        value: function getRefreshToken() {
            return getSession(SESSION_REFRESH_TOKEN_KEY);
        }
    }, {
        key: 'saveRefreshToken',
        value: function saveRefreshToken(token) {
            document.cookie = SESSION_REFRESH_TOKEN_KEY + '=' + token + ';path=/';
        }
    }, {
        key: 'deleteRefreshToken',
        value: function deleteRefreshToken() {
            document.cookie = SESSION_REFRESH_TOKEN_KEY + '=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT';
        }
    }, {
        key: 'isLoggedIn',
        value: function isLoggedIn() {
            return this.getSessionToken() !== null;
        }
    }]);
    return CookieStorage;
}();

exports.default = CookieStorage;


function getSession(key) {
    var sessionKey = key + '=';
    var cookieList = document.cookie.split(';');
    for (var i = 0; i < cookieList.length; i++) {
        var cookie = (0, _lodash.trim)(cookieList[i]);
        if (cookie.indexOf(sessionKey) === 0) {
            return cookie.substring(sessionKey.length, cookie.length);
        }
    }
    return null;
}
